<template>
  <div>
    <Form
      ref="item"
      id="lyform"
      :model="item"
      :show-message="false"
      :label-width="labelWidth ? labelWidth : 80"
      :style="{ height: height ? height + 'px' : 'auto' }"
    >
      <ul id="caculate">
        <li
          :class="{ active: selectName == x }"
          v-for="x in fffff"
          :key="x"
          @click="selectItem(x)"
        >
          {{ x }}
        </li>
      </ul>

      <Row :gutter="16">
        <Col span="8">
          <FormItem label="表单号">
            {{item.no}}
             </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="调度车辆">
            {{item.carNo}}
             </FormItem>
        </Col>
        <Col span="8">
          <FormItem label="调度司机">
            {{item.driverName}}
             </FormItem>
        </Col>
        <Col
          :span="x.span ? x.span : 8"
          v-for="(x, index) in forms"
          :key="index"
          v-show="fenlei != undefined ? x.fenlei == selectName : true"
        >
          <FormItem
            :class="{ hideLabel: x.hideLabel }"
            :label="x.title"
            :prop="x.key1 ? x.key1 : x.key"
          >
            <Input
              v-if="x.type == 'Input'"
              v-model="item[x.key]"
              :placeholder="x.placeholder || '请输入'"
              :type="x.type1"
              :rows="x.rows"
              :readonly="x.readonly"
              :disabled="x.disabled"
              :clearable="x.clearable"
              :maxlength="x.maxlength"
              :show-word-limit="x.showWordLimit"
            ></Input>
            <slot v-if="x.slotForm" :name="x.slotForm"></slot>
            <InputNumber
              v-if="x.type == 'InputNumber'"
              v-model="item[x.key]"
              :min="x.min"
              :max="x.max"
              :readonly="x.readonly"
              :disabled="x.disabled"
              :clearable="x.clearable"
              style="width: 100%"
            ></InputNumber>
            <i-switch v-model="item[x.key]" v-if="x.type == 'bool'">
              <span slot="open">{{ $t("bool.true") }}</span>
              <span slot="close">{{ $t("bool.false") }}</span>
            </i-switch>
            <RadioGroup v-model="item[x.key]" v-if="x.type == 'bool1'">
              <Radio :label="0">{{ $t("bool.false") }}</Radio>
              <Radio :label="1">{{ $t("bool.true") }}</Radio>
            </RadioGroup>
            <selectCar
              v-if="x.type == 'selectCar'"
              :name="item[x.key1]"
              @update:name="item[x.key1] = $event"
              :id="item[x.key]"
              @update:id="item[x.key] = $event"
              @car="$emit('car', $event, x.key, index)"
            >
            </selectCar>

            <selectGroup
              v-if="x.type == 'selectGroup'"
              :name="item[x.key1]"
              @update:name="item[x.key1] = $event"
              :id="item[x.key]"
              @update:id="item[x.key] = $event"
            >
            </selectGroup>
            <selectAddMap
              v-if="x.type == 'selectAddMap'"
              :address="item[x.key]"
              @update:address="item[x.key] = $event"
              :lng="item[x.keyX]"
              @update:lng="item[x.keyX] = $event"
              :lat="item[x.keyY]"
              @update:lat="item[x.keyY] = $event"
              :type="item[x.keyType]"
              @update:type="item[x.keyType] = $event"
              :readonly="x.readonly"
              :list1="x.list1"
              :list2="x.list2"
            >
            </selectAddMap>
            <AddressList
              :list="item[x.key]"
              :list1="x.list1"
              :list2="x.list2"
              v-if="x.type == 'AddressList'"
              @update:list="item[x.key] = $event"
              :noUpdate="x.noUpdate"
              :readonly="x.readonly"
            ></AddressList>
            <selectUser
              v-if="x.type == 'selectUser'"
              :name="item[x.key1]"
              @update:name="item[x.key1] = $event"
              :account="item[x.key3]"
              @update:account="item[x.key3] = $event"
              :accountId="item[x.key4]"
              @update:accountId="item[x.key4] = $event"
              :id="item[x.key]"
              @update:id="item[x.key] = $event"
              :keyword="x.keyword"
            >
            </selectUser>
            <selectFlow
              v-if="x.type == 'selectFlow'"
              v-model="item[x.key]"
            ></selectFlow>
            <lyyymmdd
              v-if="x.type == 'lyyymmdd'"
              :formate="x.formate"
              :clearable="x.clearable"
              v-model="item[x.key]"
            ></lyyymmdd>
            <ly-photo
              v-if="x.type == 'lyPhoto'"
              ref="lyphoto"
              v-model="item[x.key]"
              :one="x.one"
            ></ly-photo>

            <Select
              v-model="item[x.key]"
              style="width: 100%"
              v-if="x.type == 'Select'"
              :multiple="x.multiple"
              :readonly="x.readonly"
              :disabled="x.disabled"
              :filterable="x.filterable"
              :allow-create="x.allowCreate"
              @on-create="handleCreate1($event, x)"
              :clearable="x.clearable"
            >
              <Avatar
                :src="
                  'static/' +
                  find(x.selectItems, 'id', item[x.key], 'icon') +
                  '/4/3.gif'
                "
                slot="prefix"
                size="small"
                v-if="x.icon"
              />
              <Option
                :value="x.selectType == 'obj' ? y.id : y"
                v-for="(y, index1) in x.selectItems"
                :key="index1"
                :label="x.selectType == 'obj' ? y.name : y"
              >
                <img
                  :src="'static/' + y.icon + '/4/3.gif'"
                  width="26"
                  style="float: left; margin-top: -6px; margin-right: 10px"
                  v-if="x.icon"
                />
                <span>{{ x.selectType == "obj" ? y.name : y }}</span>
              </Option>
            </Select>
            <Select
              style="width: 100%"
              v-model="item[x.key]"
              v-if="x.type == 'Select1'"
            >
              <Option
                v-for="(y, index1) in $t(x.st)"
                :value="index1"
                :key="index1"
                >{{ x.selectType == "obj" ? y.name : y }}</Option
              >
            </Select>
            <selectPerson
              v-if="x.type == 'selectPerson'"
              :name="item[x.key1]"
              @update:name="item[x.key1] = $event"
              :id="item[x.key]"
              @update:id="item[x.key] = $event"
            >
            </selectPerson>
            <selectDriver
              v-if="x.type == 'selectDriver'"
              :name="item[x.key1]"
              @update:name="item[x.key1] = $event"
              :id="item[x.key]"
              @update:id="item[x.key] = $event"
            >
            </selectDriver>
            <ColorPicker v-model="item[x.key]" v-if="x.type == 'color'" />
            <slot v-if="x.slotForm" :name="x.slotForm"></slot>
          </FormItem>
        </Col>
      </Row> </Form
    ><slot name="content"></slot>
    <h3>领导签字</h3>
    <Table :data="tableData" :columns="columns"></Table>
  </div>
</template>
<script>
import fields from "./forms/fields";

export default {
  name: "docDetail",
  props: ["fenlei", "height", "labelWidth"],
  data() {
    return {
      item: {},
      fffff: [],
      forms: [],
      searchItem: {
        id: "",
      },
      columns: [
        {
          title: "职务",
          key: "job",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "时间",
          key: "time1",
          type: "yymmdd",
        },
        {
          title: "签字意见",
          key: "opinion",
        },
      ],
      tableData: [],
    };
  },
  methods: {
    reach(v) {
      this.forms = fields["yongcheshenqing"]; //xianxiesi
      this.item = {
        address: "",
        content: "",
        groupId: "",
        groupName: "",
        name: "",
        time: "",
        time1: new Date(),
        carIdList: [],
        carId: "",
        carNo: "",
        cs: 2,
        dept: "",
        markerIdList: [],
        personIdList: [],
        remark: "",
        routeId: 0,
        x: 0,
        y: 0,
      };
      this.searchItem.id = v.docId;
      this.getDetail();
    },
    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dpc + "/apply/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          //console.log(data);
          if (data != null) {
            this.item = data;
            var tt=data.signList;
            for (let i = 0; i < tt.length; i++) {
              tt[i].time1=this.utils.time(tt[i].time,'yymmdd')
              
            }
            setTimeout(() => {
              this.tableData = tt;
            }, 1000);
          }
        }
      });
    },
  },
};
</script>
<style>
#secsldg {
  width: 100%;
}
#secsldg td {
  width: 25%;
  padding: 6px 6px;
}
#secsldg thead tr {
  background: #f1f8fd;
}
</style>


// WEBPACK FOOTER //
// src/components/diaodu/docDetail.vue